import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, flow, observable, runInAction } from "mobx";
import moment from "moment";
import { BaseOptions } from "@devowl-wp/utils";
import { request } from "../utils/request.js";
import { locationRestStatsButtonsClickedGet } from "../wp-api/statsButtonsClicked.js";
import { locationRestStatsCustomBypassGet } from "../wp-api/statsCustomBypass.get.js";
import { locationRestStatsMainGet } from "../wp-api/statsMain.get.js";
const DATE_FORMAT = "YYYY-MM-DD";
class StatsStore extends BaseOptions {
    constructor(rootStore){
        super(), this.busyStats = {
            main: false,
            buttonClicked: false,
            customBypass: false
        }, this.stats = observable.object({
            main: undefined,
            buttonsClicked: undefined,
            customBypass: undefined
        }, {}, {
            deep: false
        }), this.filters = observable.object({
            dates: undefined,
            context: undefined
        }, {}, {
            deep: false
        }), this.fetchMain = flow(function*() {
            if (process.env.PLUGIN_CTX === "pro") {
                /* onlypro:start */ this.busyStats.main = true;
                try {
                    const dates = this.filters.dates.map((m)=>m.format(DATE_FORMAT));
                    const result = yield request({
                        location: locationRestStatsMainGet,
                        params: {
                            from: dates[0],
                            to: dates[1],
                            context: this.filters.context
                        }
                    });
                    this.stats.main = result;
                    if (result.length > 0) {
                        this.rootStore.checklistStore.probablyFetchByChangedItem("view-stats");
                    }
                } catch (e) {
                    console.log(e);
                    throw e;
                } finally{
                    this.busyStats.main = false;
                }
            /* onlypro:end */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        }), this.fetchButtonsClicked = flow(function*() {
            if (process.env.PLUGIN_CTX === "pro") {
                /* onlypro:start */ this.busyStats.buttonClicked = true;
                try {
                    const dates = this.filters.dates.map((m)=>m.format(DATE_FORMAT));
                    const result = yield request({
                        location: locationRestStatsButtonsClickedGet,
                        params: {
                            from: dates[0],
                            to: dates[1],
                            context: this.filters.context
                        }
                    });
                    this.stats.buttonsClicked = result;
                } catch (e) {
                    console.log(e);
                    throw e;
                } finally{
                    this.busyStats.buttonClicked = false;
                }
            /* onlypro:end */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        }), this.fetchCustomBypass = flow(function*() {
            if (process.env.PLUGIN_CTX === "pro") {
                /* onlypro:start */ this.busyStats.customBypass = true;
                try {
                    const dates = this.filters.dates.map((m)=>m.format(DATE_FORMAT));
                    const result = yield request({
                        location: locationRestStatsCustomBypassGet,
                        params: {
                            from: dates[0],
                            to: dates[1],
                            context: this.filters.context
                        }
                    });
                    this.stats.customBypass = result;
                } catch (e) {
                    console.log(e);
                    throw e;
                } finally{
                    this.busyStats.customBypass = false;
                }
            /* onlypro:end */ } else {
                throw new Error("This feature is not available in the free version.");
            }
        });
        this.rootStore = rootStore;
        runInAction(()=>{
            this.filters.dates = [
                moment().subtract(30, "days"),
                moment()
            ];
            this.filters.context = this.rootStore.optionStore.others.context;
        });
    }
    /**
     * This action does not actually refetch the stats, you need to act on your components!
     *
     * @param dates
     */ applyDates(dates) {
        this.filters.dates = dates;
    }
    /**
     * This action does not actually refetch the stats, you need to act on your components!
     *
     * @param context
     */ applyContext(context) {
        this.filters.context = context;
    }
}
_ts_decorate([
    observable
], StatsStore.prototype, "busyStats", void 0);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], StatsStore.prototype, "applyDates", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object
    ]),
    _ts_metadata("design:returntype", void 0)
], StatsStore.prototype, "applyContext", null);
export { StatsStore };
